import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=4c3f3115&scoped=true&"
import script from "./Download.vue?vue&type=script&lang=ts&"
export * from "./Download.vue?vue&type=script&lang=ts&"
import style0 from "./Download.vue?vue&type=style&index=0&id=4c3f3115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3f3115",
  null
  
)

export default component.exports